export default class CommonUtil {

    static hasInfoStatus(status: string) {
       const hasStatus = ['Saved', 'Submitted'].includes(status);
       return !hasStatus;
    }
} 